import {
  FRENCH_SPEAKING_COUNTRIES,
  GERMAN_SPEAKING_COUNTRIES,
  EMEA_REGION,
  AUSTRALIA_NEW_ZEALAND_REGION,
  AMERICA_REGION,
  SPAIN_ISO2,
  PORTUGAL_ISO2,
  BRAZIL_ISO2,
  LATAM_REGION
} from "services/countries/countries-service";

const TYPEFORM_CONTACT_SALES_EMEA_REGION_FORM_ID = "Rb9pva6n";
const TYPEFORM_CONTACT_SALES_FRENCH_FORM_ID = "B91EZP5w";
const TYPEFORM_CONTACT_SALES_GERMAN_FORM_ID = "onptOGWz";
const TYPEFORM_CONTACT_SALES_SPAIN_FORM_ID = "kxf82cwp";
const TYPEFORM_CONTACT_SALES_PORTUGAL_FORM_ID = "tiiFVEDy";
const TYPEFORM_CONTACT_SALES_BRAZIL_FORM_ID = "fcCPz0Z1";
const TYPEFORM_CONTACT_SALES_LATAM_REGION_FORM_ID = "MCW2vdfv";
const TYPEFORM_CONTACT_SALES_ANZ_REGION_FORM_ID = "WYNld7NX";
const TYPEFORM_CONTACT_SALES_AMERICA_REGION_FORM_ID = "Fl3WSnnm";
const TYPEFORM_CONTACT_NO_SDR_FORM_ID = "idXP35wo";

export const TYPEFORM_CONTACT_SALES_VISITOR_ID_PARAM = "visitor_id";
export const TYPEFORM_CONTACT_SALES_COUNTRY_PARAM = "country";
export const TYPEFORM_CONTACT_SALES_REGION_PARAM = "region";
export const TYPEFORM_CONTACT_SALES_KEEP_SESSION_PARAM = "keepSession";

export const getTypeformContactSalesFormId = (country, region) => {
  if (FRENCH_SPEAKING_COUNTRIES.includes(country)) return TYPEFORM_CONTACT_SALES_FRENCH_FORM_ID;
  if (GERMAN_SPEAKING_COUNTRIES.includes(country)) return TYPEFORM_CONTACT_SALES_GERMAN_FORM_ID;
  if (country === SPAIN_ISO2) return TYPEFORM_CONTACT_SALES_SPAIN_FORM_ID;
  if (country === PORTUGAL_ISO2) return TYPEFORM_CONTACT_SALES_PORTUGAL_FORM_ID;
  if (country === BRAZIL_ISO2) return TYPEFORM_CONTACT_SALES_BRAZIL_FORM_ID;

  switch (region) {
    case EMEA_REGION:
      return TYPEFORM_CONTACT_SALES_EMEA_REGION_FORM_ID;
    case AUSTRALIA_NEW_ZEALAND_REGION:
      return TYPEFORM_CONTACT_SALES_ANZ_REGION_FORM_ID;
    case AMERICA_REGION:
      return TYPEFORM_CONTACT_SALES_AMERICA_REGION_FORM_ID;
    case LATAM_REGION:
      return TYPEFORM_CONTACT_SALES_LATAM_REGION_FORM_ID;
    default:
      return TYPEFORM_CONTACT_NO_SDR_FORM_ID;
  }
};
